import React from 'react';
import { x } from '@xstyled/styled-components';

export default function SocialMedia(props) {
  return (
    <x.div display="flex" justifyContent="space-between" {...props}>
      <x.div pr={{ xs: 4, xl: 8 }}>
        <a
          href="https://twitter.com/axiomatics"
          target="_blank"
          rel="noreferrer"
        >
          <svg
            width="30"
            height="24"
            viewBox="0 0 30 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M26.9287 5.97474C26.947 6.23512 26.947 6.4955 26.947 6.75829C26.947 14.7654 20.7556 24 9.43449 24V23.9952C6.09019 24 2.81536 23.0569 0 21.2786C0.486289 21.3362 0.975015 21.365 1.46496 21.3662C4.23644 21.3686 6.9287 20.453 9.10908 18.7671C6.47532 18.7179 4.16575 17.0272 3.35893 14.559C4.28154 14.7342 5.23218 14.6982 6.13772 14.4546C3.2663 13.8834 1.20049 11.3996 1.20049 8.51498C1.20049 8.48858 1.20049 8.46338 1.20049 8.43818C2.05606 8.90735 3.01402 9.16774 3.99391 9.19653C1.28946 7.41705 0.45582 3.87487 2.08897 1.10545C5.21389 4.89121 9.8245 7.19266 14.7739 7.43625C14.2779 5.33158 14.9555 3.12612 16.5545 1.64661C19.0335 -0.647644 22.9324 -0.530052 25.2626 1.90939C26.6411 1.64181 27.9622 1.14384 29.1712 0.438287C28.7118 1.841 27.7502 3.03252 26.4656 3.78968C27.6856 3.64808 28.8775 3.32651 30 2.83574C29.1737 4.05486 28.1328 5.11679 26.9287 5.97474Z"
              fill="#1D9BF0"
            />
          </svg>
        </a>
      </x.div>
      <x.div pr={{ xs: 4, xl: 8 }}>
        <a
          href="https://www.linkedin.com/company/536082"
          target="_blank"
          rel="noreferrer"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M24 20.6667C24 22.508 22.508 24 20.6667 24H3.33333C1.49267 24 0 22.508 0 20.6667V3.33333C0 1.492 1.49267 0 3.33333 0H20.6667C22.508 0 24 1.492 24 3.33333V20.6667Z"
              fill="#0078D4"
            />
            <path
              opacity="0.01"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3 8.57692V21H7.57692V8.57692H5.27865C6.60988 8.57692 7.57692 7.61119 7.57692 6.27473C7.55012 4.93565 6.61315 4 5.29762 4C3.96638 4 3 4.96246 3 6.28781C3 7.61446 3.95069 8.57692 5.26035 8.57692H3ZM15.4231 14.3968V21H20L19.9993 13.9868C19.9993 10.5993 18.2248 8.57692 15.2518 8.57692C14.2952 8.57692 13.4759 8.80969 12.8077 9.27065V8.57692H8.23077V21H12.8077L12.8064 14.253C12.7998 13.7371 12.8155 13.5664 12.8267 13.5246C13.0653 12.9328 13.457 12.6327 13.9898 12.6327C14.8876 12.6327 15.4231 13.2925 15.4231 14.3968Z"
              fill="black"
            />
            <path
              opacity="0.07"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3 6.03932C3 7.22184 3.84592 8.08 5.01076 8.08H5.0298C6.21776 8.08 7.08 7.22184 7.08 6.03252C7.0562 4.83572 6.22184 4 5.04952 4C3.86224 4 3 4.85748 3 6.03932ZM3 21V8.76H7.08V21H3ZM15.92 21V14.4727C15.92 13.131 15.2189 12.298 14.0894 12.298C13.2088 12.298 12.7736 12.9182 12.5642 13.4384C12.5094 13.5713 12.5157 14.0916 12.5185 14.3274L12.5186 14.3401L12.52 21H8.44V8.76H12.52V9.87384C13.0606 9.3142 13.931 8.76 15.4018 8.76C18.2803 8.76 19.9993 10.7361 19.9993 14.0463L20 21H15.92Z"
              fill="black"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.65667 7.33333H5.638C4.64333 7.33333 4 6.592 4 5.666C4 4.72 4.66333 4 5.676 4C6.69 4 7.31467 4.72 7.33333 5.666C7.33333 6.59133 6.69 7.33333 5.65667 7.33333ZM4 8.66667H7.33333V20H4V8.66667ZM16.6667 20H20L19.9993 13.516C19.9993 10.1667 18.2107 8.66667 15.8253 8.66667C13.9 8.66667 13.1473 9.66667 12.6667 10.4107V8.66667H9.33333V20H12.6667V14C12.6667 13.9444 12.6658 13.8794 12.6649 13.8088C12.6605 13.4658 12.6544 12.9888 12.734 12.7953C12.9967 12.1433 13.538 11.4687 14.5387 11.4687C15.85 11.4687 16.6667 12.4687 16.6667 13.934V20Z"
              fill="white"
            />
          </svg>
        </a>
      </x.div>
      <x.div pr={{ xs: 4, xl: 8 }}>
        <a
          href="https://www.youtube.com/user/axiomaticsab"
          target="_blank"
          rel="noreferrer"
        >
          <svg
            width="108"
            height="24"
            viewBox="0 0 108 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <mask
              id="mask0"
              mask-type="alpha"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="34"
              height="24"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 0H34V24H0V0Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask0)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M33.289 3.74736C32.8979 2.27246 31.7454 1.11055 30.2818 0.716283C27.629 0 16.9914 0 16.9914 0C16.9914 0 6.35421 0 3.70141 0.716283C2.23781 1.11055 1.0853 2.27246 0.694126 3.74736C-0.0168152 6.42143 -0.0168152 11.9999 -0.0168152 11.9999C-0.0168152 11.9999 -0.0168152 17.5786 0.694126 20.2524C1.0853 21.7273 2.23781 22.8895 3.70141 23.2834C6.35421 24 16.9914 24 16.9914 24C16.9914 24 27.629 24 30.2818 23.2834C31.7454 22.8895 32.8979 21.7273 33.289 20.2524C34 17.5786 34 11.9999 34 11.9999C34 11.9999 34 6.42143 33.289 3.74736Z"
                fill="#D9252A"
              />
            </g>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13 17L22 12.0003L13 7V17Z"
              fill="#FFFFFE"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M53.4541 19.0708C53.6344 18.5985 53.725 17.8269 53.725 16.7561V12.2442C53.725 11.2047 53.6344 10.445 53.4541 9.96454C53.2735 9.48437 52.9553 9.244 52.5 9.244C52.0601 9.244 51.7496 9.48437 51.5692 9.96454C51.3886 10.445 51.2983 11.2047 51.2983 12.2442V16.7561C51.2983 17.8269 51.3846 18.5985 51.5576 19.0708C51.7301 19.5434 52.0441 19.7794 52.5 19.7794C52.9553 19.7794 53.2735 19.5434 53.4541 19.0708ZM49.8024 21.3385C49.1502 20.898 48.6867 20.2128 48.4122 19.2834C48.1372 18.3546 48 17.1183 48 15.575V13.4726C48 11.9135 48.1568 10.6614 48.4711 9.71657C48.7851 8.77171 49.2757 8.08298 49.9437 7.64985C50.6111 7.21671 51.4868 7 52.5708 7C53.6388 7 54.4947 7.22078 55.1388 7.66154C55.7826 8.10256 56.2539 8.79156 56.5525 9.72853C56.8506 10.6655 57 11.9135 57 13.4726V15.575C57 17.1183 56.8546 18.3584 56.5642 19.2954C56.2735 20.2324 55.8021 20.9176 55.1504 21.3502C54.4985 21.7833 53.6152 22 52.5 22C51.3531 22 50.4538 21.7792 49.8024 21.3385Z"
              fill="#222321"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M101.75 9.5079C101.578 9.71296 101.463 10.0482 101.406 10.5133C101.348 10.9788 101.32 11.6844 101.32 12.6307V13.6718H103.803V12.6307C103.803 11.7004 103.77 10.9946 103.705 10.5133C103.639 10.0324 103.521 9.69336 103.349 9.49619C103.176 9.29902 102.91 9.20016 102.549 9.20016C102.188 9.20016 101.922 9.3031 101.75 9.5079ZM101.32 15.6119V16.3456C101.32 17.2761 101.348 17.9741 101.406 18.4393C101.463 18.9047 101.582 19.2437 101.762 19.4567C101.943 19.6697 102.221 19.7761 102.598 19.7761C103.106 19.7761 103.455 19.5869 103.643 19.2081C103.832 18.8298 103.934 18.1988 103.951 17.3154L106.877 17.4809C106.893 17.6076 106.902 17.781 106.902 18.0016C106.902 19.3423 106.521 20.344 105.758 21.0065C104.996 21.6686 103.918 22 102.525 22C100.853 22 99.6804 21.4956 99.0085 20.4858C98.336 19.4769 98 17.915 98 15.8012V13.2696C98 11.0929 98.3484 9.50409 99.0453 8.50218C99.7418 7.50082 100.935 7 102.623 7C103.787 7 104.68 7.20507 105.303 7.61492C105.926 8.02533 106.365 8.66422 106.619 9.53159C106.873 10.3992 107 11.598 107 13.1277V15.6119H101.32Z"
              fill="#222321"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M41.8209 16.1917L38 2H41.3341L42.6725 8.43264C43.0134 10.018 43.2647 11.3695 43.4269 12.4873H43.5244C43.6378 11.6864 43.8894 10.3433 44.2788 8.4577L45.6659 2H49L45.1306 16.1917V23H41.8209V16.1917Z"
              fill="#222321"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M67 7V21.7594H64.401L64.1121 19.9536H64.0401C63.334 21.318 62.2751 22 60.8635 22C59.8849 22 59.1631 21.6793 58.6977 21.0369C58.2324 20.3954 58 19.3918 58 18.0275V7H61.3208V17.8348C61.3208 18.4933 61.3931 18.9625 61.5375 19.2433C61.6818 19.5243 61.9225 19.6645 62.2593 19.6645C62.5482 19.6645 62.8249 19.5767 63.0894 19.3996C63.3542 19.2233 63.5506 18.9988 63.6792 18.7259V7H67Z"
              fill="#222321"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M85 7V21.7594H82.401L82.1121 19.9536H82.0403C81.3337 21.318 80.2751 22 78.8635 22C77.8849 22 77.1631 21.6793 76.6977 21.0369C76.2324 20.3954 76 19.3918 76 18.0275V7H79.3208V17.8348C79.3208 18.4933 79.3929 18.9625 79.5372 19.2433C79.6818 19.5243 79.9225 19.6645 80.2593 19.6645C80.5482 19.6645 80.8249 19.5767 81.0894 19.3996C81.3542 19.2233 81.5506 18.9988 81.6792 18.7259V7H85Z"
              fill="#222321"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M77 4.7782H73.6503V23H70.3497V4.7782H67V2H77V4.7782Z"
              fill="#222321"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M93.7593 15.4548C93.7593 16.5221 93.716 17.3584 93.6307 17.9633C93.5454 18.5692 93.4015 18.999 93.1994 19.2536C92.9973 19.5085 92.7249 19.6359 92.3835 19.6359C92.1189 19.6359 91.8741 19.5723 91.649 19.4445C91.4232 19.3171 91.241 19.1263 91.1009 18.8711V10.5572C91.2096 10.1595 91.3961 9.83284 91.6605 9.57765C91.9249 9.32328 92.212 9.19568 92.5231 9.19568C92.8497 9.19568 93.102 9.32713 93.281 9.58975C93.4595 9.85237 93.584 10.2946 93.6541 10.9158C93.7241 11.5367 93.7593 12.4208 93.7593 13.5676V15.4548ZM96.7085 9.48112C96.514 8.55769 96.1991 7.8889 95.7641 7.47448C95.3288 7.06062 94.7303 6.85355 93.9689 6.85355C93.3782 6.85355 92.8264 7.02487 92.3135 7.36696C91.8006 7.70961 91.4039 8.1595 91.1243 8.71691H91.1006L91.1009 1H88V21.785H90.6578L90.9844 20.3995H91.0542C91.3027 20.8931 91.6758 21.2834 92.1734 21.5702C92.6707 21.8567 93.2228 22 93.829 22C94.9168 22 95.7174 21.4863 96.2305 20.4592C96.7434 19.4315 97 17.8272 97 15.6451V13.3278C97 11.6874 96.9026 10.4054 96.7085 9.48112Z"
              fill="#222321"
            />
          </svg>
        </a>
      </x.div>
    </x.div>
  );
}
